import { render } from "./AuthComponent.vue?vue&type=template&id=7678ff7c&scoped=true"
import script from "./AuthComponent.vue?vue&type=script&lang=js"
export * from "./AuthComponent.vue?vue&type=script&lang=js"

import "./AuthComponent.vue?vue&type=style&index=0&id=7678ff7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7678ff7c"]])

export default __exports__